import { useQuery, useQueryClient, useMutation } from 'react-query';

import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import {
  getBannedWords,
  addBannedWord,
  editBannedWord,
  deleteBannedWord,
} from './actions';

export const useBannedWords = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-banned-words', params],
    queryFn: getBannedWords,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useAddBannedWord = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(addBannedWord, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-banned-words');
      toastSuccess('Successfully added banned word!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useEditBannedWord = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(editBannedWord, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-banned-words');
      toastSuccess('Successfully updated banned word!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useDeleteBannedWord = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(deleteBannedWord, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-banned-words');
      toastSuccess('Successfully deleted banned word!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export default {};
